import { _ as _sliced_to_array } from "@swc/helpers/_/_sliced_to_array";
import { jsx as _jsx } from "react/jsx-runtime";
import { Decorative } from "@faire/design-tokens";
import { InventoryLevelsTable } from "@faire/retailer-visitor-shared/views/point-of-sale/landing-page/components/InventoryLevelsTable";
import { optimizeImageUrl } from "@faire/web--source/common/images/optimizeImages";
import { useIsSSR } from "@faire/web--source/common/server-side-rendering/isSSR";
import { Row } from "@faire/web--source/slate/Layout";
import { useViewport } from "@faire/web--source/ui/hooks/useViewport";
import React, { useEffect } from "react";
import styled from "styled-components";
var ANIMATION_INTERVAL_MS = 2000;
export var InventoryLevelsIllustration = function() {
    var isTabletAndBelow = useViewport().isTabletAndBelow;
    var isSSR = useIsSSR();
    var _React_useState = _sliced_to_array(React.useState(false), 2), isSynced = _React_useState[0], setIsSynced = _React_useState[1];
    useEffect(function() {
        var intervalId = setInterval(function() {
            setIsSynced(function(prevIsSynced) {
                return !prevIsSynced;
            });
        }, ANIMATION_INTERVAL_MS);
        return function() {
            return clearInterval(intervalId);
        };
    }, []);
    if (isTabletAndBelow) {
        return /*#__PURE__*/ _jsx(TabletAndBelowContainer, {
            align: "center",
            justify: "center",
            children: /*#__PURE__*/ _jsx(InventoryLevelsTable, {
                isSynced: isSynced
            })
        });
    }
    return /*#__PURE__*/ _jsx(DesktopContainer, {
        align: "center",
        justify: "center",
        $imageUrl: optimizeImageUrl({
            url: "https://cdn.faire.com/fastly/c6dda467e3f5f74b63637bbb2ef795eb047943acc21b83265e19b0b4d6760cea.png"
        }, isSSR),
        children: /*#__PURE__*/ _jsx(InventoryLevelsTable, {
            isSynced: isSynced
        })
    });
};
var TabletAndBelowContainer = styled(Row).withConfig({
    componentId: "sc-74d311f0-0"
})([
    "height:343px;width:100%;max-width:584px;background-color:",
    ";user-select:none;"
], Decorative.icon.neutral);
var DesktopContainer = styled(Row).withConfig({
    componentId: "sc-74d311f0-1"
})([
    "height:584px;width:100%;max-width:584px;background-image:url(",
    ");background-repeat:no-repeat;background-size:cover;user-select:none;"
], function(props) {
    return props.$imageUrl;
});
